// src/components/ProductPage/ColorSelector.js
import React from 'react';
import { Box, Typography, Avatar } from '@mui/material';

const ColorSelector = ({ 
  productColors, 
  selectedColorIndex, 
  handleColorChange 
}) => {
  return (
    <Box sx={{ mb: 4 }}>
      <Typography 
        variant="h6" 
        sx={{ 
          mb: 2,
          fontWeight: 'bold',
          color: '#333'
        }}
      >
        اللون: {productColors[selectedColorIndex]?.colors?.name || productColors[selectedColorIndex]?.color}
      </Typography>
      
      <Box sx={{ 
        display: 'flex', 
        gap: 2, 
        flexWrap: 'wrap'
      }}>
        {productColors.map((colorItem, index) => (
          <Box
            key={colorItem.id}
            onClick={() => handleColorChange(index)}
            sx={{
              cursor: 'pointer',
              transition: 'transform 0.2s ease',
              '&:hover': { transform: 'scale(1.05)' }
            }}
          >
            <Avatar
              sx={{
                width: 60,
                height: 60,
                border: selectedColorIndex === index 
                  ? '4px solid #0f3662' 
                  : '2px solid #e0e0e0',
                boxShadow: selectedColorIndex === index 
                  ? '0 0 0 2px rgba(15, 54, 98, 0.2)' 
                  : 'none',
                backgroundColor: '#f5f5f5'
              }}
              src={colorItem.product_color_images?.[0]?.image_url}
              alt={colorItem.colors?.name || colorItem.color}
            >
              {!colorItem.product_color_images?.[0]?.image_url && 
                (colorItem.colors?.name?.[0] || colorItem.color?.[0])}
            </Avatar>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ColorSelector;
